// packages/world-model/src/traits/openable/index.ts

export * from './openableTrait';
export * from './openableBehavior';